export const ADVANCED_FEATURES_ENABLED = process.env.REACT_APP_ADVANCED === "true";
